/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
const mdSize = {height: 11, borderRadius: 'base'}

export default {
    sizes: {
        md: {
            field: {...mdSize, px: 3},
            addon: mdSize
        }
    },
    baseStyle: {
        field: {
            flex: 1,
            mr: 2,
            border: 'none',
            borderRadius: 0,
            borderBottom: '1px solid',
            borderColor: 'gray.900',
            paddingRight: '40px',
            paddingLeft: 0,
            marginRight: 0,
            // Safari-specific fix for Helvetica Neue vertical alignment
            '@supports (-webkit-hyphens: none)': {
                paddingTop: '0.35em',
                paddingBottom: '0.05em'
            },
            _hover: {
                borderColor: 'gray.900'
            },
            _focusVisible: {
                borderColor: 'gray.900'
            },
            _invalid: {
                borderColor: 'dangerText'
            }
        }
    },
    variants: {
        outline: {
            field: {
                border: 'none',
                borderBottom: '1px solid',
                borderRadius: 0,
                borderColor: 'gray.700',
                lineHeight: '18px',
                _hover: {
                    borderColor: 'gray.700'
                },
                _focusVisible: {
                    borderColor: 'gray.700',
                    boxShadow: 'none'
                },
                _invalid: {
                    borderColor: 'dangerText',
                    boxShadow: 'none'
                },
                _disabled: {
                    opacity: 1,
                    color: 'gray.700',
                    background: 'grey.300'
                }
            }
        },
        filled: {
            // we use filled variant for
            // search input
            field: {
                borderColor: 'gray.600',
                backgroundColor: 'gray.100',
                _focus: {
                    backgroundColor: 'white'
                },
                _hover: {
                    backgroundColor: 'gray.100',
                    _focus: {
                        backgroundColor: 'white'
                    }
                },
                _placeholder: {
                    color: 'gray.700'
                }
            }
        },
        calendarCustom: {
            field: {
                border: 'none',
                borderBottom: '1px solid',
                borderRadius: 0,
                borderColor: 'gray.700',
                _hover: {
                    borderColor: 'gray.500'
                },
                _focusVisible: {
                    borderColor: 'gray.500',
                    boxShadow: 'none'
                },
                _invalid: {
                    borderColor: 'dangerText',
                    boxShadow: 'none'
                },
                _disabled: {
                    opacity: 1,
                    color: 'gray.700',
                    background: 'grey.300'
                },
                '&::-webkit-calendar-picker-indicator': {
                    bg: `transparent url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16' fill='none'%3E%3Cpath d='M10.6667 1.3335V3.3335M5.33333 1.3335V3.3335M14 6.00016H2M2 14.6668H14V2.66683H2V14.6668Z' stroke='black' stroke-linecap='square'/%3E%3C/svg%3E") no-repeat center center/16px`,
                    width: '16px',
                    height: '16px',
                    cursor: 'pointer',
                    opacity: 1,
                }
            }
        }
    }
}
